import type { FunctionComponent } from 'react';
import Link from '@media-ui/core/src/components/Link';
import Text from '@media-ui/core/src/components/Text';
import Button from '@media-ui/core/src/components/Button';
import * as s from './HeadlineTooltipMenu.css';
import * as T from './HeadlineTooltipMenu.types';
const HeadlineTooltipMenu: FunctionComponent<T.IHeadlineTooltipMenu> = (props) => {
    const { menuLinks } = props;
    const isMenu = menuLinks && Boolean(menuLinks.length);
    return (<div className={s.wrapper}>
      <Button.Link dataQaDetail="AddPetButton" href="/my/pet/add/" className={s.root}>
        Добавить питомца
      </Button.Link>

      {isMenu &&
            menuLinks.map((menu, index) => (<Button key={index} className={s.root}>
            <Link href={menu?.href} className={s.link}>
              <Text>{menu?.text}</Text>
            </Link>
          </Button>))}
    </div>);
};
HeadlineTooltipMenu.displayName = 'HeadlineTooltipMenu';
export default HeadlineTooltipMenu;
